import { render, staticRenderFns } from "./persona-fisica.vue?vue&type=template&id=4dcd76f6&scoped=true"
import script from "./persona-fisica.vue?vue&type=script&lang=js"
export * from "./persona-fisica.vue?vue&type=script&lang=js"
import style0 from "./persona-fisica.vue?vue&type=style&index=0&id=4dcd76f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcd76f6",
  null
  
)

export default component.exports